import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeConverter'
})
export class DateTimeConverterPipe implements PipeTransform {

  extractInfoFromDateTime(dateTime: string, dataType: string): string {
    return dataType === 'time' ? dateTime.split(' ')[1] : dateTime.split(' ')[0];
  }

  transform(value: any, dataType: 'time'|'date'): any {
    if (typeof value === 'string') {
      return this.extractInfoFromDateTime(value, dataType);
    } else if (value instanceof Array) {
      return value.map((dateTime) => {
        return this.extractInfoFromDateTime(dateTime, dataType);
      }).join(', ');
    }
  }

}
